import React, { useMemo } from "react";
import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import { row } from "@ui/style";
import { CheckmarkIcon } from "@ui/components/common/checkmark-icon";
import { GetStartedStepStatus } from "@domain/get-started/get-started";

interface StepIconProps {
	status: GetStartedStepStatus;
}

export const StepIcon: React.FC<StepIconProps> = ({ status }) => {
	const { format } = useI18n();

	const { color, backgroundColor, border } = useMemo(() => {
		switch (status) {
			case GetStartedStepStatus.Default:
				return { color: colors.grey25, backgroundColor: undefined, border: true };
			case GetStartedStepStatus.Completed:
				return { color: colors.white, backgroundColor: colors.validation, border: false };
			case GetStartedStepStatus.Disabled:
				return { color: `${colors.grey50}33`, backgroundColor: undefined, border: true };
		}
	}, [status]);

	return (
		<Container>
			<StyledCheckmarkIcon
				size="M"
				colors={{ circle: backgroundColor, check: color }}
				border={border ? `2px dashed ${color};` : undefined}
			/>
			{status === GetStartedStepStatus.Completed && (
				<CompletedStatus className="p-size-s">{format("getStarted.checkIcon.completed")}</CompletedStatus>
			)}
		</Container>
	);
};

const Container = styled.div`
	${row("XS", "flexstart", "center")};
`;

const StyledCheckmarkIcon = styled(CheckmarkIcon)<{ border?: string }>`
	${({ border }) => border && `border: ${border};`}
`;

const CompletedStatus = styled.div`
	color: ${colors.grey};
`;
